import React, { useState, useEffect, useRef } from "react";
import "../asset/css/multiSelectDropdown.css";
import downArrow from "../asset/img/icon/downArrow.png";
import { MultiSelectDropdownProps } from "../utils/Type";

const MultiSelectDropdown: React.FC<MultiSelectDropdownProps> = ({
    options,
    label,
    value = [],
    onChange,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState<string[]>(value);
    const [searchText, setSearchText] = useState("");

    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target as Node)
            ) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleCheckboxChange = (optionValue: string) => {
        const updatedOptions = selectedOptions.includes(optionValue)
            ? selectedOptions.filter((val) => val !== optionValue)
            : [...selectedOptions, optionValue];
        setSelectedOptions(updatedOptions);
        onChange(updatedOptions);
    };

    const handleSelectAll = () => {
        const allValues = options.map((option) => option.value);
        setSelectedOptions(
            selectedOptions.length === options.length ? [] : allValues
        );
        onChange(
            selectedOptions.length === options.length ? [] : allValues
        );
    };

    const filteredOptions = options.filter((option) =>
        option.label.toLowerCase().includes(searchText.toLowerCase())
    );

    const selectedLabels = options
        .filter(option => selectedOptions.includes(option.value))
        .map(option => option.label);

    return (
        <div ref={dropdownRef} className="multi-select-dropdown-container">
            {label && <label className="multi-select-dropdown-label">{label}</label>}
            <div
                className="multi-select-dropdown-header"
                onClick={() => setIsOpen((prev) => !prev)}
            >
                <span className={selectedOptions.length > 0 ? 'placeholder-style-selected' : 'placeholder-style'}>
                    {selectedLabels.length
                        ? `${selectedLabels.join(', ')}`
                        : "Veuillez sélectionner"}
                </span>
                <img
                    src={downArrow}
                    className="multi-select-dropdown-arrow"
                    alt="Arrow"
                />
            </div>

            {isOpen && (
                <div className="multi-select-dropdown-options">
                    <div className="multi-select-dropdown-search">
                        <input
                            type="text"
                            placeholder="Rechercher..."
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                            className="multi-select-dropdown-search-input"
                        />
                    </div>

                    <div className="multi-select-dropdown-select-all">
                        <label className="multi-select-dropdown-select-all-label">Tout sélectionner</label>
                        <input
                            type="checkbox"
                            className="custom-checkbox"
                            checked={selectedOptions.length === options.length}
                            onChange={handleSelectAll}
                        />
                    </div>

                    {filteredOptions.map((option) => (
                        <div
                            key={option.value}
                            className={`multi-select-dropdown-option ${selectedOptions.includes(option.value) ? 'selected' : ''}`}
                        >
                            <label className="multi-select-dropdown-option-label">
                                {option.label}
                            </label>
                            <input
                                type="checkbox"
                                className="custom-checkbox"
                                checked={selectedOptions.includes(option.value)}
                                onChange={() => handleCheckboxChange(option.value)}
                            />
                            
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MultiSelectDropdown;